<!-- 
Layout for pages that don't do anything but redirect to another page.
Shows a progress indicator and has a slot so that explanatory text can be included
(e.g. "Opening preview of the invoice PDF, please wait...")
-->
<template>
  <div>
    <v-content>
      <div class="scroll-container">
        <div>
          <v-container fluid>
            <p class="text-xs-center mt-5 pt-5">
              <v-progress-circular indeterminate size="60" width="10" color="primary"/>
              <slot/>
            </p>
          </v-container>
        </div>
      </div>
    </v-content>
    <notification-snackbar />
  </div>
</template>

<script>
import NotificationSnackbar from "@/components/system/NotificationSnackbar.vue";

export default {
  components: { NotificationSnackbar }
};
</script>
